import React, { useEffect, useState, useRef, Fragment } from 'react';
import Loading from '../../shared/Loading';
import { Row, Col, Container, Card } from 'reactstrap';
import Constants from '../../../Constants';
import { currentUser } from '../../../services/CurrentUser';
import { isMobileOnly } from "react-device-detect";
import EirModal from '../../eir-modal/EirModal';
import axios from 'axios';
import EirCustomiseClearCart from './EirCustomiseClearCart';
import { css } from 'emotion';
import EirCustomiseOrderSummaryStepper from '../EirCustomiseOrderSummaryStepper';
import {
    Paper, Grid, Box,
    Typography, Button,
    Stepper, Step, StepLabel
} from '@material-ui/core';
import { pushOrder } from '../../../utils/Analytics';
import { eraseCookie } from '../../../utils/cookie';


function EirCustomiseHomePhone(props) {

    const [detailedOrderSummary, setDetailedOrderSummary] = React.useState([]);
    const [totalItems, setTotalItems] = React.useState([]);
    const [paymentBreakdown, setPaymentBreakdown] = React.useState([]);
    const [openPaymentBreakdown, setOpenPaymentBreakdown] = React.useState(false);
    const [setupFeesSummary, setSetupFeesSummary] = React.useState([]);
    const [showEmptyCart, setShowEmptyCart] = React.useState(false);
    // const [eirBeData, setEirBeData]=React.useState('');

    const [editText, setEditText] = React.useState('Edit cart');
    const [editActive, setEditActive] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [deleteConfirmationModal, setDeleteConfirmationModal] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState('');
    const [overlayCopy, setOverlayCopy] = React.useState('');
    const [standAlone, setStandAlone] = useState(false);
    const [mobileBroadband, setMobileBroadband] = useState(false);
    const [standAloneSimOnly, setStandAloneSimOnly] = useState(false);
    const [standAlonePrepayPhone, setStandAlonePrepayPhone] = useState(false);
    const [newCust, setnewCust] = useState(true);
    const [checkBillpayInCart, setCheckBillpayInCart] = useState(false);

    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
    const myRef = useRef(null)
    let data = (localStorage.getItem('eir_be_data')) ? (JSON.parse(localStorage.getItem('eir_be_data')).order.bundle) : '';

    const stylings = {
        deleteIcon: css`
            background-position: left center; 
            background-image:  url("data:image/svg+xml,%3Csvg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.69837 2.2046L7.69841 2.2046L7.69824 2.20166C7.66822 1.67214 7.43671 1.17419 7.0512 0.809954C6.6657 0.445715 6.15543 0.2428 5.62506 0.242834C5.07438 0.242834 4.54625 0.461595 4.15685 0.850991C3.79109 1.21675 3.57588 1.70492 3.5511 2.21921H0.456087V2.21897L0.44924 2.21944L0.387212 2.2237L0.387196 2.22347L0.380459 2.2244C0.247329 2.24267 0.12532 2.30854 0.0369953 2.40981C-0.0513293 2.51108 -0.0999943 2.64091 -0.1 2.77529H-0.100235L-0.0997653 2.78214L-0.0955086 2.84417L-0.095739 2.84419L-0.0948141 2.85092C-0.0765386 2.98405 -0.0106738 3.10606 0.0905996 3.19439C0.191873 3.28271 0.321704 3.33138 0.456083 3.33138H0.456087H0.848895L1.61902 11.1582L1.61896 11.1582L1.6194 11.1615L1.63338 11.2674L1.63334 11.2674L1.63383 11.2704C1.70157 11.6854 1.9147 12.0629 2.23513 12.3352C2.55556 12.6076 2.9624 12.7572 3.38294 12.7572H7.86719V12.7572L7.8706 12.7571L7.97763 12.7535L7.97763 12.7535L7.98061 12.7533C8.40012 12.7265 8.79643 12.5514 9.09877 12.2593C9.40111 11.9672 9.58979 11.5772 9.63112 11.1589L9.63112 11.1588L10.4006 3.33138H10.7941V3.33162L10.8009 3.33115L10.8629 3.32689L10.8629 3.32712L10.8697 3.32619C11.0093 3.30699 11.1364 3.23552 11.2253 3.12622C11.3142 3.01693 11.3583 2.87796 11.3487 2.73739C11.3391 2.59683 11.2765 2.46515 11.1735 2.36896C11.0706 2.27278 10.935 2.21925 10.7941 2.21921H10.7941H7.69876L7.69837 2.2046ZM1.9663 3.33138H9.28265L8.52506 11.0463L8.51371 11.1179C8.45173 11.4215 8.18335 11.645 7.86719 11.645H3.3853L3.31325 11.6416C3.16263 11.6256 3.02206 11.5583 2.91516 11.4509C2.80764 11.3429 2.74079 11.201 2.72598 11.0493L2.72597 11.0493L1.9663 3.33138ZM7.24087 5.29091L7.2411 5.2909L7.24017 5.28416C7.2219 5.15103 7.15603 5.02902 7.05476 4.9407C6.95349 4.85237 6.82365 4.80371 6.68928 4.8037C6.54179 4.8037 6.40035 4.86229 6.29606 4.96658C6.19177 5.07086 6.13318 5.2123 6.13318 5.35979V9.6166H6.13295L6.13342 9.62344L6.13768 9.68547L6.13744 9.68549L6.13838 9.69226C6.15758 9.83183 6.22905 9.95892 6.33834 10.0478C6.44764 10.1367 6.58661 10.1809 6.72717 10.1713C6.86774 10.1616 6.99942 10.099 7.09561 9.9961C7.19179 9.89314 7.24532 9.75752 7.24536 9.61663V9.6166V5.35979H7.24559L7.24512 5.35294L7.24087 5.29091ZM5.11246 5.29091L5.11269 5.2909L5.11177 5.28416C5.09349 5.15103 5.02763 5.02902 4.92635 4.9407C4.82508 4.85237 4.69525 4.80371 4.56087 4.8037C4.41338 4.8037 4.27194 4.86229 4.16765 4.96658C4.06337 5.07086 4.00478 5.2123 4.00478 5.35979V9.6166H4.00454L4.00501 9.62344L4.00927 9.68547L4.00904 9.68549L4.00997 9.69226C4.02918 9.83183 4.10065 9.95892 4.20994 10.0478C4.31923 10.1367 4.4582 10.1809 4.59877 10.1713C4.73934 10.1616 4.87101 10.099 4.9672 9.9961C5.06339 9.89314 5.11691 9.75752 5.11695 9.61663V9.6166V5.35979H5.11719L5.11672 5.35294L5.11246 5.29091ZM4.97195 1.60993C5.14996 1.44601 5.38309 1.35502 5.62507 1.35501C5.88079 1.35501 6.12604 1.45659 6.30686 1.63742C6.46396 1.79451 6.56125 2.00024 6.58408 2.21921H4.66611C4.69043 1.98589 4.79904 1.76916 4.97195 1.60993Z' fill='%23D111C9' stroke='%23D111C9' stroke-width='0.2'/%3E%3C/svg%3E%0A");
            background-size: contain;
            height: 24px;
            width: 24px;
            `
    }

    const getCart = async () => {
        if (currentUser.getAttribute(Constants.cacheKeys.orderId)) {

            //console.log(">>>> Updating Cart >>>>");
            let response = await fetch('/store/api/cart');
            let cart = await response.json();

            PubSub.publish(Constants.eventKeys.cartSubscriberAdded, cart);
            //console.log("No of products in the cart>>>>>>", cart.numberOfProducts);
            /*to update number of items in the cart*/
            $(".cart-quantity").html(cart.numberOfProducts);

        }
        else {
            // console.log(">>>> Clearing Cart >>>>");
            // console.log(" >>>> Loading empty cart screen ");
            var cartEmpty = { 'cartDetails': { 'numberOfProducts': 0 } };
            PubSub.publish(Constants.eventKeys.cartSubscriberAdded, cartEmpty);
            setIsLoading(false);
            $(".cart-quantity").hide();
            setShowEmptyCart(true);
        }
    };
    useEffect(() => {
        const cartDetailsOnOrder = async () => {
            try {
                let resp = await fetch('/store/api/cart/');
                let cart = await resp.json();
                let url = cart && cart.bundle && cart.bundle.plans[0] && cart.bundle.plans[0].removeUrl;
                let checkSimOnly = data && data.mobiles[0] && data.mobiles[0].simOnly;
                let checkMobileInCart = data &&  data.mobiles && data.mobiles.length;

                //** display text when a billpay plan and phone is in the order*/
                if (checkSimOnly === true || checkSimOnly === "") {
                    setCheckBillpayInCart(false)
                }
                else if (url.includes('prepay') === true) {
                    setCheckBillpayInCart(false)
                }
                else if (url.includes('bill') === true) {
                    setCheckBillpayInCart(true)
                }
                else if (checkMobileInCart > 0) {
                    setCheckBillpayInCart(true)
                }
                else {
                    setCheckBillpayInCart(false)
                }

                if (cart.id == undefined) throw 'No item in cart found';
                else {
                    await setTimeout(() => {
                        const custType = localStorage.getItem("global_customer_type");

                        //** check customer type and hide setup fees*/
                        if (custType == "new") {
                            setnewCust(true);
                        }
                        else {
                            setnewCust(false);
                        }
                        getOrderSummary();
                    }, 2500);
                }
                setShowEmptyCart(false)
            }
            catch (er) {
                console.log("Cart is empty");
                setShowEmptyCart(true)
            }
        }
        // setTimeout(() => {
        //     const custType = localStorage.getItem("global_customer_type");

        //     //** check customer type and hide setup fees*/
        //     if (custType == "new") {
        //         setnewCust(true);
        //     }
        //     else {
        //         setnewCust(false);
        //     }
        //     getOrderSummary();
        // }, 2500);
        cartDetailsOnOrder();
        pushOrder();
    }, []);//end of useEffect

    const getOrderSummary = () => {
        setIsLoading(true);
        var readCookie = document.cookie.split(";");
        var getOrderId = "";
        var orderSummary = [];
        var totalItems = [];
        var paymentBreakdown = [];
        var setupFees = [];
        var orderTitle = "";
        var orderName = "";
        var enableIcon = false;
        var tvAddOns = false;
        for (var i = 0; i < readCookie.length; i++) {
            if (readCookie[i].indexOf("eir_current_order") > 0) {
                getOrderId = readCookie[i].split("=")[1];
            }
        }
        setIsLoading(true);
        fetch('/store/customise-plan?orderId=' + getOrderId).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error('Something went wrong');
            }
        })
            .then((resp) => {
                //console.log("bedata resp >>>> ", resp);
                localStorage.setItem("eir_be_data", JSON.stringify(resp));
                //let contractSections = resp.bundleDetails.contractSections;
                setStandAlone((resp.bundleDetails === undefined) ? true : false);
                setMobileBroadband((resp.order.bundle.hasMobileBroadbandPostpay || resp.order.bundle.hasMobileBroadbandPrepay));
                setStandAlonePrepayPhone(resp.order.bundle.standaloneMobilePrepay);
                setStandAloneSimOnly(resp.order.bundle.standaloneMobile && !resp.order.bundle.standaloneMobilePrepay);
                if (!(resp.bundleDetails === undefined && resp.order.bundle.standaloneMobilePrepay)) {
                    //console.log('removing prepay-phone-plan from localstorage')
                    localStorage.removeItem('prepay-phone-plan');
                }
                let contractSections = (resp.bundleDetails !== undefined) ? resp.bundleDetails.contractSections : '';
                var priceBreakdown = resp.order.priceBreakdown;
                var bundleProducts = 'Broadband, Landline';
                var activationFee = 0;
                var totalActivationFee = 0;
                var totalInstallationFee = 0;
                var installationFee = 0;
                if (resp.order.hasActivationFee && resp.order.hasInstallationFee) {
                    $.each(resp.order.standardFees, function (i, fee) {
                        if (fee.feeType === 'ACTIVATION') {
                            activationFee += (fee.feeAmount - fee.feeDiscount);
                            totalActivationFee = fee.feeAmount;
                        }
                        if (fee.feeType === 'INSTALLATION') {
                            installationFee += (fee.feeAmount - fee.feeDiscount);
                            totalInstallationFee = fee.feeAmount;
                        }
                    })
                }
                for (var i = 0; i < contractSections.length; i++) {
                    if (contractSections[i].contractLength < 25) {
                        let products = contractSections[i].products;
                        var BroadbandTitleCount, TVTitleCount, MobileTitleCount;

                        for (var j = 0; j < products.length; j++) {
                            if ((products[j].title.toLowerCase().includes('tv') || products[j].title.toLowerCase().includes('multiroom'))
                                && bundleProducts.indexOf("TV") < 0) {

                                bundleProducts += ', TV'
                            }
                        }

                        for (var j = 0; j < products.length; j++) {

                            if (products[j].title.toLowerCase().includes('fibre') || products[j].title.toLowerCase().includes('broadband') || products[j].title.toLowerCase().includes('talk') || products[j].title.toLowerCase().includes('landline')) {
                                if (!BroadbandTitleCount) {
                                    orderTitle = '';
                                    orderName = products[j].title;
                                    BroadbandTitleCount = 1;
                                }
                            }
                            else if (products[j].title.toLowerCase().includes('tv') || products[j].title.toLowerCase().includes('multiroom')) {
                                orderName = products[j].title;
                                enableIcon = true;
                                if (!TVTitleCount) {
                                    orderTitle = '';
                                    TVTitleCount = 1;
                                }
                                if (products[j].title.toLowerCase().includes('multiroom') || products[j].title.toLowerCase().includes('extra') || products[j].title.toLowerCase().includes('racing')) {
                                    tvAddOns = true;
                                }
                            }
                            else if (products[j].title.toLowerCase().includes('mobile')) {
                                orderName = products[j].title;
                                enableIcon = true;
                                if (!MobileTitleCount) {
                                    orderTitle = '';
                                    MobileTitleCount = 1;
                                }
                            }
                            orderSummary.push({
                                type: orderTitle,
                                name: orderName,
                                ContractLength: tvAddOns ? '30 day contract' : contractSections[i].title,
                                price: '',
                                deleteIcon: enableIcon,
                            });
                            orderTitle = "";
                            enableIcon = false;
                            tvAddOns = false;
                        }
                    }
                }

                if (resp.order.bundle.mobiles.length > 0) {
                    bundleProducts += ', Mobile'
                }
                orderSummary.splice(0, 0,
                    {
                        type: 'Bundle',
                        name: bundleProducts.replace(/,(?=[^,]*$)/, ' &'),
                        price: JSON.parse(localStorage.getItem('eir_be_data')).order.formattedPromoMonthlyCost

                    });

                var bundleOffers = JSON.parse(localStorage.getItem("bundleOffers"));
                orderTitle = 'Offers'
                // if (activationFee == 0 || installationFee == 0) {
                //     orderSummary.push({
                //         type: orderTitle,
                //         name: (activationFee == 0 && installationFee == 0) ? 'Free Installation & Free Activation'
                //             : ((activationFee == 0 && installationFee > 0) ? 'Free Activation' : 'Free Installation'),
                //         price: 'Free'
                //     });
                //     orderTitle = "";
                // }
                if (bundleOffers) {
                    for (i = 0; i < bundleOffers.length; i++) {
                        orderSummary.push({
                            type: orderTitle,
                            name: bundleOffers[i].OfferDescription,
                            price: 'Free'
                        });
                        orderTitle = "";
                    }
                }
                //standalone - billpay phone
                if (resp.order.bundle.standaloneMobile && !resp.order.bundle.standaloneMobilePrepay) {
                    orderSummary.push({
                        type: 'Plan',
                        name: resp.order.bundle.mobiles[0].plan.name,
                        ContractLength: (!resp.order.bundle.mobiles[0].simOnly && resp.order.bundle.mobiles[0].simOnly !== undefined) ? resp.order.bundle.mobiles[0].contract.contractLength + " months" : (resp.order.bundle.mobiles[0].contract.contractLength * 30) + " days",
                        price: parseFloat(resp.order.formattedPromoMonthlyCost).toFixed(2)
                    })

                }


                //console.log("orderSummary >>> ", orderSummary);

                if (resp.order.bundle.mobiles.length > 0 && !resp.order.bundle.mobiles[0].simOnly) {
                    orderSummary.push({
                        type: (resp.order.bundle.hasMobileBroadbandPostpay || resp.order.bundle.hasMobileBroadbandPrepay) ? 'Device' : 'Phone',
                        name: resp.order.bundle.mobiles[0].handset.name,
                        price: parseFloat(resp.order.bundle.mobiles[0].handsetPrice).toFixed(2),
                        color: resp.order.bundle.mobiles[0].handset.variant.name,
                        deleteIcon: true,
                    })
                }
                setDetailedOrderSummary(orderSummary);

                if (resp.order.bundle.mobiles.length > 0 && !resp.order.bundle.mobiles[0].simOnly) {
                    totalItems.push({
                        type: 'Pay today',
                        name: resp.order.bundle.mobiles[0].handset.name,
                        price: parseFloat(resp.order.bundle.mobiles[0].handsetPrice).toFixed(2),
                        color: resp.order.bundle.mobiles[0].handset.variant.name,
                        deleteIcon: true,
                    })
                }
                orderTitle = 'Monthly cost';
                totalItems.push({
                    type: orderTitle,
                    name: (resp.order.bundle.mobiles[0] !== undefined && !resp.order.bundle.mobiles[0].simOnly && !resp.mobilesOnOrder && !resp.order.bundle.hasMobileBroadbandPostpay) ? 'Month 1 to 24' : 'Month 1*',
                    ContractLength: (resp.order.bundle.standaloneMobile && !resp.order.bundle.standaloneMobilePrepay) ? '' : ((localStorage.getItem("global_customer_type") == 'new') ? 'Includes activation and installation fees' : ''),
                    price: (resp.order.bundle.standaloneMobile && !resp.order.bundle.standaloneMobilePrepay) ? parseFloat(resp.order.formattedPromoMonthlyCost).toFixed(2) : (priceBreakdown != null) ? parseFloat(priceBreakdown[0].priceFormatted).toFixed(2) : ''
                });
                orderTitle = "";

                if (priceBreakdown != null) {
                    for (var i = 1; i < priceBreakdown.length; i++) {

                        if (i == 1) {
                            paymentBreakdown.push({
                                type: orderTitle,
                                name: 'Month ' + (priceBreakdown[i].startMonth + 1) + '+',
                                price: priceBreakdown[i].priceFormatted
                            });
                        }
                        else {
                            paymentBreakdown.push({
                                type: orderTitle,
                                name: 'Month ' + (priceBreakdown[i].startMonth + 1) + '+',
                                price: priceBreakdown[i].priceFormatted
                            });
                        }
                    }
                }
                setTotalItems(totalItems);
                setPaymentBreakdown(paymentBreakdown);
                setupFees.push({
                    type: 'Fees',
                    name: 'Installation fee',
                    Price: (totalInstallationFee > installationFee) ? totalInstallationFee : 0,
                    offerPrice: (installationFee == 0) ? 'Free' : parseFloat(installationFee).toFixed(2)
                })
                setupFees.push({
                    type: '',
                    name: 'Activation fee',
                    Price: (totalActivationFee > activationFee) ? totalActivationFee : 0,
                    offerPrice: (activationFee == 0) ? 'Free' : parseFloat(activationFee).toFixed(2)
                })
                setSetupFeesSummary(setupFees);
                setIsLoading(false);

            })
            .catch((error) => {
                console.log(error)
                setIsLoading(false);
                //setShowEmptyCart(true);
            });
    }// end of getOrderSummary

    const displayPaymentBreakdown = () => {
        setOpenPaymentBreakdown(!openPaymentBreakdown);
    }



    const editToggle = () => {
        if (editActive) {
            setEditText('Edit cart');
            setEditActive(false);
        }
        else {
            setEditText('Cancel');
            setEditActive(true);
        }

    }

    const handleModalToggle = () => {
        setDeleteConfirmationModal(!deleteConfirmationModal);
    }

    // Remove from cart
    const removeFromCart = () => {

        const ORDER = JSON.parse(localStorage.getItem('eir_be_data'));

        const removeAPICall = (url) => axios({
            method: 'post',
            url: url,
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then((res) => {
            handleModalToggle();
            getCart();
            getOrderSummary();

        }).catch(err => console.err('removeFromCart() Error => ', err));

        // all urls for order item removal 
        const removeURL = {
            TV: {
                base: `/store/api/config/remove-tv/${ORDER.order.id}`,
                addOn: `/store/api/basket/remove-tv-addon/${ORDER.order.id}`,
                multiroom: `/store/api/basket/remove-multiroom/${ORDER.order.id}`,
            },
            Mobile: `/store/api/config/remove-mobile/${ORDER.order.id}`
        }

        // -------- remove TV plans ---------

        const TV = {
            // base: deleteItem == 'eir TV',
            base: deleteItem == ((ORDER.order.bundle.tv) ? ORDER.order.bundle.tv.plan.name : null),
            addOn: ((ORDER.tvAddOnDtosOnOrder) ? ORDER.tvAddOnDtosOnOrder.filter(addOn => addOn.name == deleteItem) : []),
            multiroom: deleteItem.toUpperCase().indexOf('MULTIROOM') >= 0,
        }

        if (TV.base || TV.multiroom || TV.addOn.length > 0) {
            TV.base && removeAPICall(removeURL.TV.base)
            TV.multiroom && removeAPICall(removeURL.TV.multiroom)
            TV.addOn.length > 0 && removeAPICall(`${removeURL.TV.addOn}/${TV.addOn[0].r6Key}`)
        }
        // -------- remove TV plans ---------

        // -------- remove MOBILE plans ---------
        const Mobile = {
            base: ORDER.mobilesOnOrder.filter(item => item.plan.name == deleteItem).length > 0,
            handset: ORDER.mobilesOnOrder.filter(item => item.handset.name == deleteItem).length > 0
        }

        if (Mobile.base || Mobile.handset) {
            var mblOrderId = ORDER.mobilesOnOrder[0].id;
            removeAPICall(`${removeURL.Mobile}/${mblOrderId}`)
        }
        // -------- remove MOBILE plans ---------
    }

    const clearCustomiseCart = () => {
        localStorage.removeItem('prospectUuid');
        localStorage.removeItem('offerId');
        localStorage.removeItem('plan-name');
        localStorage.removeItem('handset-name');
        localStorage.removeItem('prepayHandsetId');
        localStorage.removeItem('IONOrderReference');
        localStorage.removeItem('planToggle');
        localStorage.removeItem('eir_be_data');
        localStorage.removeItem('orderId');
        localStorage.removeItem('eir_prequal_order');
        $.removeCookie('eir_current_order', { path: '/' });
        eraseCookie("eir_current_order", ".eir.ie")
        eraseCookie("eir_current_order", "www.eir.ie")
        getCart();
    };

    // Delete-Confirmation Modal 
    const confirmDelete = (e) => {
        // console.log("=====orderName===", e.target.id);
        // if (e.target.id == 'Phone')
        // {
        // var mobileOrderExists = JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder;
        // if (mobileOrderExists.length > 0) config.mobile.api.remove(mobileOrderExists[0].id);
        // }

        if (e.target.id == 'Phone') {
            setOverlayCopy(<p>You want to delete the <b>{totalItems[0].name}</b>.</p>)
        }
        else if (e.target.id == 'Mobile') {
            setOverlayCopy(<p>Do you want to remove sim and plan?</p>)
            // setOverlayCopy('Do you want to remove sim and plan?')
        }
        else {
            setOverlayCopy(<p>You want to delete the <b>{e.target.id}</b>.</p>)
        }

        setDeleteConfirmationModal(true);
        setDeleteItem(e.target.id);

    }

    return (


        <Grid className="orderSummary-container">
            {showEmptyCart ?
                <EirCustomiseClearCart /> :
                <Fragment>
                    <EirCustomiseOrderSummaryStepper />

                    <div class="orderSummary-main mt-0">


                        {isLoading &&
                            <Loading className="m-5" />
                        }
                        {!isLoading && !showEmptyCart &&
                            <div class="orderSummaryHeading w-100 purple-text d-flex justify-content-center align-items-center">Your Order Summary</div>
                        }
                        {!isLoading && !showEmptyCart &&
                            <div className="clear-order">
                                <Row className="col-12 mr-0 ml-0 pr-0 pl-0 row justify-content-end">
                                    <a onClick={clearCustomiseCart} title="clear cart" class="clear-cart-link">Clear cart </a>
                                </Row>

                            </div>}

                        {detailedOrderSummary && !isLoading && !showEmptyCart &&
                            <Card className="three_six_card three_six_card_order_summary">

                                <div className="p-4 d-flex justify-content-center align-items-center main-heading">{(standAlonePrepayPhone) ? "Phone" : "Package"}</div>
                                <div className={(isMobileOnly) ? "pl-4 pr-0 pb-2" : "pl-4 pr-4 pb-5"}>
                                    {detailedOrderSummary &&
                                        detailedOrderSummary.map((order, i) => {
                                            return (
                                                <Row className={

                                                    (isMobileOnly) ? "col-12 mt-0 pl-0 pr-0 " + order.type + "standalone-" + standAlone : "col-12 mt-3 pl-4 pr-4 " + order.type + "standalone-" + standAlone
                                                }>
                                                    <Col className={"col-xs-3 order-type purple-font " + ((order.type == "Bundle") ? ' bundleBorder' : '') + ((order.type == "Phone") ? ' packagePhone' : '') + ((order.type == "Monthly cost") ? ' h-50' : '') + ((isMobileOnly && order.type != '') ? ' h-line' : '') + order.type + "standalone-" + standAlone + ((isMobileOnly && order.type == 'Phone' && standAlone) ? ' h-line' : '') + ((isMobileOnly && order.type == 'Phone' && standAlonePrepayPhone) ? ' prepayexist-line' : '')}>{order.type}</Col>
                                                    <Col id={'bundleTitle' + i} className={"col-xs-7 order-name " + ((order.type == '') ? 'emptyBundle ' : '') + ((order.type == '' && order.price == "Free") ? 'emptyOffers ' : '') + ((i != 0 && order.type != '') ? 'h-line' : '') + ((order.type == 'Plan') && (standAlone) ? 'prepay-line' : '') + ((order.type == 'Phone') && (standAlone) ? 'standh-line' : '') + ((order.type == 'Phone') && (standAlonePrepayPhone) ? 'standh-line ' : '') + ((isMobileOnly && order.type == 'Phone' && standAlone) ? ' h-line' : '')}>{order.name}{(order.color) ? <span className="mobilePhone-color ">{' - ' + order.color}</span> : ''}<span className="mt-1 d-block order-ContractLength">{order.ContractLength}</span></Col>
                                                    {(order.price != 'Free' && order.price != 'Included' && order.price != '') ?
                                                        <Col className={"col-xs-2 order-price " + ((order.type == 'Phone') ? 'moveIcon ' : '') + ((i != 0 && order.type != '') ? 'h-line ' : '') + ((order.type == 'Plan') && (standAlone) ? 'standalonehline ' : '') + ((order.type == 'Phone') && (standAlonePrepayPhone) ? 'standline ' : '') + ((order.type == "Monthly cost") ? ' purple-font ' : '') + ((order.ContractLength || order.type == "Monthly cost") ? 'pt-20' : '')}>&euro;{order.price}{(order.type == "Your Monthly Payment Breakdown") ? <span>*</span> : ''}{(order.deleteIcon && editActive) ? <span><img id={order.name} onClick={confirmDelete} className="deleteIconImg" src="/.galleries/customise-page/DeleteIcon_D111C9.png"></img></span> : ''}</Col> :
                                                        <Col className={"col-xs-2 order-price " + ((order.type == '') ? 'pt-0 ' : '') + ((i != 0 && order.type != '') ? 'h-line ' : '') + ((order.type == "Monthly cost") ? ' purple-font ' : '')}>{order.price}{(order.deleteIcon && editActive) ? <span><img id={order.name} onClick={confirmDelete} className="deleteIconImg" src="/.galleries/customise-page/DeleteIcon_D111C9.png"></img></span> : ''}</Col>
                                                    }
                                                </Row>
                                            );
                                        })
                                    }
                                </div>
                            </Card>
                        }



                        {newCust && setupFeesSummary && !isLoading && !showEmptyCart && !standAlone &&
                            <Card className="three_six_card three_six_card_order_summary mt-5">
                                <div className="p-4 d-flex justify-content-center align-items-center main-heading">Setup Fees - added to your first bill</div>
                                <div className={(isMobileOnly) ? "pl-4 pr-0 pb-2" : "pl-4 pr-4 pb-5"}>
                                    {setupFeesSummary &&
                                        setupFeesSummary.map((order, i) => {
                                            return (
                                                <Row className={
                                                    (isMobileOnly) ? "col-12 mt-0 pl-0 pr-0" : "col-12 mt-3 pl-4 pr-4"}>
                                                    <Col className={"col-xs-3 order-type purple-font "}>{order.type}</Col>
                                                    <Col className={"col-xs-7 order-name " + ((order.type == '') ? 'emptyFees ' : '')}>{order.name}</Col>
                                                    {(order.offerPrice != 'Free') ?
                                                        <Col className={"col-xs-2 order-price " + ((order.type == '') ? 'emptyFees ' : '')}>{order.Price > 0 && <span className="mr-3 strike-through">&euro;{order.Price}</span>}&euro;{order.offerPrice}</Col>
                                                        : <Col className={"col-xs-2 order-price " + ((order.type == '') ? 'emptyFees ' : '')}>{order.Price > 0 && <span className="mr-3 strike-through">&euro;{order.Price}</span>}{order.offerPrice}</Col>
                                                    }
                                                </Row>
                                            );
                                        })
                                    }
                                </div>
                            </Card>
                        }

                        {totalItems.length > 0 && !isLoading && !showEmptyCart &&
                            <div>
                                <Card className="three_six_card three_six_card_order_summary mt-5">
                                    <div className="p-4 d-flex justify-content-center align-items-center main-heading">Total </div>
                                    <div className={(isMobileOnly) ? "pl-4 pr-0 pb-4" : "pl-4 pr-4 pb-5"}>
                                        {totalItems.length > 0 &&
                                            totalItems.map((order, i) => {
                                                return (
                                                    <Row className={(isMobileOnly) ? "col-12 mt-0 pl-0 pr-0 standaloneprepayphone-" + standAlonePrepayPhone + " standAloneSimOnly-" + standAloneSimOnly : "col-12 mt-3 pl-4 pr-4  standaloneprepayphone-" + standAlonePrepayPhone + " standAloneSimOnly-" + standAloneSimOnly}>
                                                        <Col className={"col-xs-3 order-type purple-font " + ((order.type == "Monthly cost") ? ' h-50' : '') + ((order.type == "Pay today") ? ' borderPay' : '') + ((isMobileOnly && order.type != '') ? ' h-line' : '') + ((isMobileOnly && order.type == 'Monthly cost' && standAlonePrepayPhone) ? 'standprepayline' : '') + ((isMobileOnly && order.type == 'Monthly cost' && standAloneSimOnly) ? 'simonly' : '') + ((isMobileOnly) && (order.type == 'Monthly cost' && standAloneSimOnly) ? '' : '')}>{order.type}</Col>
                                                        <Col className={"col-xs-7 order-name " + ((order.type == '') ? 'emptyMonthlyCost ' : '') + ((order.type == 'Monthly cost') ? 'monthOne ' : '') + ((i != 0 && order.type != '') ? 'h-line' : '')}>{order.name} {(order.color) ? <span className="mobilePhone-color ">{' - ' + order.color}</span> : ''}<span className="mt-1 d-block order-ContractLength">{order.ContractLength}</span></Col>
                                                        {(order.price != 'Free' && order.price != 'Included') ?
                                                            <Col className={"col-xs-2 order-price " + ((order.type == '') ? 'emptyMonthlyCost ' : '') + ((i != 0 && order.type != '') ? 'h-line ' : '') + ((order.type == "Pay today") ? ' purple-font ' : '') + ((order.ContractLength || order.type == "Monthly cost") ? 'pt-20' : '')}>&euro;{order.price}{(order.type == "Your Monthly Payment Breakdown") ? <span>*</span> : ''}</Col> :
                                                            <Col className={"col-xs-2 order-price " + ((i != 0 && order.type != '') ? 'h-line ' : '')}>{order.price}</Col>
                                                        }
                                                    </Row>
                                                );
                                            })
                                        }
                                        {paymentBreakdown.length > 0 &&
                                            <div>
                                                <Row>
                                                    <Col className={"col-xs-3 order-type purple-font "} >{ }</Col>
                                                    <Col className={"col-xs-7 payment-breakdown "}>Payment Breakdown</Col>
                                                    <Col className={"col-xs-2 order-price "}><span><img onClick={displayPaymentBreakdown} className="dropDownImg" src="/.galleries/customise-page/DropDown.png"></img></span></Col>

                                                </Row>
                                                {openPaymentBreakdown &&
                                                    paymentBreakdown.map((order, i) => {
                                                        return (
                                                            <Row className={(isMobileOnly) ? "col-12 mt-0 pl-0 pr-0" : "col-12 mt-3 pl-4 pr-4"}>
                                                                <Col className={"col-xs-3 order-type purple-font " + ((order.type == "Monthly cost") ? ' h-50' : '') + ((isMobileOnly && order.type != '') ? ' h-line' : '')}>{order.type}</Col>
                                                                <Col className={"col-xs-7 order-name " + ((order.type == '') ? 'emptyPayment ' : '') + ((i != 0 && order.type != '') ? 'h-line' : '')}>{order.name} {(order.color) ? <span className="mobilePhone-color ">{' - ' + order.color}</span> : ''}<span className="mt-1 d-block order-ContractLength">{order.ContractLength}</span></Col>
                                                                {(order.price != 'Free' && order.price != 'Included') ?
                                                                    <Col className={"col-xs-2 order-price " + ((order.type == '') ? 'emptyPayment ' : '') + ((i != 0 && order.type != '') ? 'h-line ' : '') + ((order.type == "Monthly cost") ? ' purple-font ' : '') + ((order.ContractLength || order.type == "Monthly cost") ? 'pt-20' : '')}>&euro;{order.price}{(order.type == "Your Monthly Payment Breakdown") ? <span>*</span> : ''}</Col> :
                                                                    <Col className={"col-xs-2 order-price " + ((i != 0 && order.type != '') ? 'h-line ' : '') + ((order.type == "Monthly cost") ? ' purple-font ' : '')}>{order.price}</Col>
                                                                }
                                                            </Row>
                                                        );
                                                    })
                                                }

                                            </div>
                                        }
                                    </div>
                                </Card>
                                {totalItems.length > 0 && !isLoading && !showEmptyCart && !mobileBroadband && checkBillpayInCart &&
                                    <div className="align-right disclaimer"><strong>Please Note: &nbsp;</strong>You may be asked to pay a deposit when purchasing a handset</div>
                                }
                                {detailedOrderSummary && !isLoading && !showEmptyCart && !mobileBroadband && checkBillpayInCart ?
                                    <div className="mb-4 align-right pt-0 disclaimer">* Your first bill will contain Part Period Charges which cover the period of time from the activation of your services until the issue of the first bill.</div> :
                                    <div className="align-right pt-4 disclaimer">* Your first bill will contain Part Period Charges which cover the period of time from the activation of your services until the issue of the first bill.</div>
                                }
                            </div>
                        }


                        {!isLoading && !showEmptyCart &&
                            <div class="order-summary-button">
                                <Row className=" mr-0 mb-5 ">
                                    {!standAlone &&
                                        <Col className="col-9">
                                            <div className="edit-cart text-right" onClick={editToggle} >{editText} <img className="editIconImg" src=" /.galleries/customise-page/EditIcon.png"></img></div>
                                        </Col>
                                    }
                                    <Col className={standAlone ? "col-12" : "col-3"}>
                                        <a type
                                            href={standAlone && localStorage.getItem('prepay-phone-plan') == "/store/mobile/phones/prepay/" ?
                                                "/store/checkout/" : "/checkout/customer-details/"}
                                            title="confirm & continue" class="confirm-cta">Confirm & Continue </a>
                                    </Col>
                                </Row>
                            </div>
                        }
                    </div>
                    {!isLoading &&
                        <EirModal
                            className='checkout-delete-modal'
                            centered={true}
                            img={"/opencms/export/sites/default/.galleries/checkout/closeIcon.png"}
                            Modal={deleteConfirmationModal}
                            handleToggle={handleModalToggle}
                            OverlayHeading={'Are you sure?'}
                            OverlayCopy1={overlayCopy}
                            cta2={true}
                            cta2outline={true}
                            cta2type="button"
                            cta2text="Yes, Delete"
                            cta2title="Remove"
                            cta2onClick={removeFromCart}

                            cta1={true}
                            cta1outline={true}
                            cta1type="button"
                            cta1text="No, Cancel"
                            cta1title="Cancel"
                            cta1onClick={handleModalToggle}>

                        </EirModal>
                    }
                </Fragment>
            }
        </Grid>

    );
}
export default EirCustomiseHomePhone;